@file:Suppress("SpellCheckingInspection")

package xim.poc.game.configuration.v0.constants

import xim.poc.game.configuration.MonsterId

val mobWildRabbit_2 = MonsterId(2)
val mobMinerBee_3 = MonsterId(3)
val mobSeaboardVulture_4 = MonsterId(4)
val mobAtomicCluster_5 = MonsterId(5)
val mobBigclaw_6 = MonsterId(6)
val mobMakara_7 = MonsterId(7)
val mobCherryTree_8 = MonsterId(8)
val mobCherrySapling_9 = MonsterId(9)

val mobColkhab_10 = MonsterId(10)
val mobWagglingWasp_11 = MonsterId(11)
val mobFerociousFunguar_12 = MonsterId(12)
val mobWildSheep_13 = MonsterId(13)
val mobGadfly_14 = MonsterId(14)
val mobLapinion_15 = MonsterId(15)
val mobLoathsomeLeech_16 = MonsterId(16)
val mobBlanchedMandy_17 = MonsterId(17)
val mobBelaboringWasp_18 = MonsterId(18)

val mobKraken_19 = MonsterId(19)
val mobEft_20 = MonsterId(20)
val mobJagil_21 = MonsterId(21)
val mobOpoopo_22 = MonsterId(22)
val mobAlraune_28 = MonsterId(28)
val mobClot_23 = MonsterId(23)
val mobUragnite_24 = MonsterId(24)
val mobWarMachine_25 = MonsterId(25)
val mobExplosive_26 = MonsterId(26)

val mobKnottedRoots_27 = MonsterId(27)
val mobTchakka_29 = MonsterId(29)
val mobHoaryCraklaw_30 = MonsterId(30)
val mobCareeningTwitherym_31 = MonsterId(31)
val mobLeafdancerTwitherym_32 = MonsterId(32)
val mobDuskprowlers_33 = MonsterId(33)
val mobBlightdella_34 = MonsterId(34)
val mobRipsawJagil_35 = MonsterId(35)
val mobTarichuk_36 = MonsterId(36)
val mobPerfidiousCrab_37 = MonsterId(37)
val mobScummySlug_38 = MonsterId(38)

val mobPolarHare_39 = MonsterId(39)
val mobIceElemental_40 = MonsterId(40)
val mobNivalRaptor_41 = MonsterId(41)
val mobBuffalo_42 = MonsterId(42)
val mobTiger_43 = MonsterId(43)
val mobSnoll_44 = MonsterId(44)
val mobSnollTzar_45 = MonsterId(45)

val mobWanderer_46 = MonsterId(46)
val mobWeeper_47 = MonsterId(47)
val mobThinker_48 = MonsterId(48)
val mobGorger_49 = MonsterId(49)
val mobCraver_50 = MonsterId(50)
val mobSeether_51 = MonsterId(51)
val mobSelhteus_52 = MonsterId(52)
val mobMemoryReceptacle_53 = MonsterId(53)
val mobProcreator_54 = MonsterId(54)
val mobCumulator_55 = MonsterId(55)
val mobAgonizer_56 = MonsterId(56)
val mobOffspring_57 = MonsterId(57)

val mobWamoura_58 = MonsterId(58)
val mobWamouracampa_59 = MonsterId(59)
val mobApkallu_60 = MonsterId(60)
val mobEbonyPudding_61 = MonsterId(61)
val mobTrollIronworker_62 = MonsterId(62)
val mobTrollTargeteer_63 = MonsterId(63)
val mobTrollSmelter_64 = MonsterId(64)
val mobAssassinFly_65 = MonsterId(65)
val mobVolcanicLeech_66 = MonsterId(66)
val mobFriarsLantern_67 = MonsterId(67)
val mobMagmaEruca_68 = MonsterId(68)
val mobCerberus_69 = MonsterId(69)
val mobCerberusFetter_70 = MonsterId(70)

val mobSeedMandragora_71 = MonsterId(71)
val mobDancingWeapon_72 = MonsterId(72)
val mobMagicPot_73 = MonsterId(73)
val mobClipper_74 = MonsterId(74)
val mobGreaterPugil_75 = MonsterId(75)
val mobSeedGoblin_76 = MonsterId(76)
val mobSeedYagudo_77 = MonsterId(77)
val mobSeedQuadav_78 = MonsterId(78)
val mobSeedOrc_79 = MonsterId(79)
val mobGiantGateKeeper_80 = MonsterId(80)
val mobGiantLobber_81 = MonsterId(81)
val mobChaosIdol_82 = MonsterId(82)
val mobPorphyrion_83 = MonsterId(83)
val mobSeedCrystal_84 = MonsterId(84)
val mobSeedThrall_85 = MonsterId(85)

val mobHyoscya_86 = MonsterId(86)
val mobRafflesia_87 = MonsterId(87)
val mobCheekyOpoOpop_88 = MonsterId(88)
val mobTwitherym_89 = MonsterId(89)
val mobSnapweed_90 = MonsterId(90)
val mobCorpseFlower_91 = MonsterId(91)
val mobYumcax_92 = MonsterId(92)
val mobFlatusAcuex_93 = MonsterId(93)
val mobLividUmbril_94 = MonsterId(94)
val mobAsperousMarolith_95 = MonsterId(95)
val mobTenebrousObdella_96 = MonsterId(96)
val mobBalasBats_97 = MonsterId(97)
val mobPallidFunguar_98 = MonsterId(98)
val mobSubterraneSpider_99 = MonsterId(99)
val mobPungentFungus_100 = MonsterId(100)
val mobNumbingBlossom_101 = MonsterId(101)
val mobYumcaxWatcher_102 = MonsterId(102)

val mobShadowLord_103 = MonsterId(103)
val mobIronQuadav_104 = MonsterId(104)
val mobVajraQuadav_105 = MonsterId(105)
val mobYagudoTemplar_106 = MonsterId(106)
val mobYagudoChanter_107 = MonsterId(107)
val mobOrcishVeteran_108 = MonsterId(108)
val mobOrcishProphetess_109 = MonsterId(109)
val mobFustyGnole_110 = MonsterId(110)
val mobCointeach_111 = MonsterId(111)
val mobDireGargouille_112 = MonsterId(112)
val mobDemonWarrior_113 = MonsterId(113)
val mobDemonBefouler_114 = MonsterId(114)
val mobVarkolak_115 = MonsterId(115)
val mobBerserkerDemon_116 = MonsterId(116)
val mobEclipseDemon_117 = MonsterId(117)
val mobTitanotaur_118 = MonsterId(118)
val mobDoomLens_119 = MonsterId(119)
val mobZirnitra_120 = MonsterId(120)
val mobZirnitrasFetter_121 = MonsterId(121)
val mobShadowLordClone_122 = MonsterId(122)
val mobShadowEye_123 = MonsterId(123)
val mobShadowImage_124 = MonsterId(124)

val mobEchoBats = MonsterId(125)
val mobLuckybug = MonsterId(126)
val mobSupernalChapuli = MonsterId(127)
val mobEldertaur = MonsterId(128)
val mobMindertaur = MonsterId(129)
val mobGurfurlur = MonsterId(130)
val mobCargoCrab = MonsterId(131)
val mobDreadPincer = MonsterId(132)
val mobFriendlyLeafkin = MonsterId(133)
val mobWhiteConey = MonsterId(134)
val mobBlackConey = MonsterId(135)

val mobBurrowerWorm_M1 = MonsterId(1001)
val mobDingBats_M2 = MonsterId(1002)
val mobDiggerLeech_M3 = MonsterId(1003)

val mobLesserWivre_M = MonsterId(1010)
val mobManeatingHornet_M = MonsterId(1011)
val mobWalkingSapling_M = MonsterId(1012)
val mobHugeSpider_M = MonsterId(1013)

val mobWightBlm_M = MonsterId(1020)
val mobWightWar_M = MonsterId(1021)
val mobBanshee_M = MonsterId(1022)
val mobOreEater_M = MonsterId(1023)
val mobMautheDoog_M = MonsterId(1024)

val mobBugbearDeathsman_M = MonsterId(1030)
val mobPurgatoryBat_M = MonsterId(1031)
val mobMoblinAidman_M = MonsterId(1032)
val mobMoblinRoadman_M = MonsterId(1033)
val mobMoblinEngineman_M = MonsterId(1034)
val mobMoblinJunkman_M = MonsterId(1035)
val mobMoblinHangman_M = MonsterId(1036)

val petColkhab = MonsterId(2001)
val petYumcax = MonsterId(2002)
val petSelhteus = MonsterId(2003)
val petHadhayosh = MonsterId(2004)
val petTchakka = MonsterId(2005)
val petAkash = MonsterId(2006)
val petSlime = MonsterId(2007)
val petWyvern = MonsterId(2008)

val mobIfrit_100_000 = MonsterId(100_000)
val mobTitan_100_005 = MonsterId(100_005)
val mobLeviathan_100_010 = MonsterId(100_010)
val mobGaruda_100_015 = MonsterId(100_015)
val mobShiva_100_020 = MonsterId(100_020)
val mobRamuh_100_025 = MonsterId(100_025)
val mobCarbuncle_100_030 = MonsterId(100_030)
val mobFenrir_100_035 = MonsterId(100_035)


val mobPlateauGlider_135_001 = MonsterId(135_001)
val mobLaTheineLiege_135_002 = MonsterId(135_002)
val mobFarfadet_135_003 = MonsterId(135_003)
val mobBabaYaga_135_004 = MonsterId(135_004)
val mobCarabosse_135_005 = MonsterId(135_005)
val mobAkash_135_006 = MonsterId(135_006)
val mobHadalGigas_135_007 = MonsterId(135_007)
val mobPantagruel_135_008 = MonsterId(135_008)
val mobDemersalGigas_135_009 = MonsterId(135_009)
val mobGrandgousier_135_010 = MonsterId(135_010)
val mobBathyalGigas_135_011 = MonsterId(135_011)
val mobAdamastor_135_012 = MonsterId(135_012)
val mobBriareus_135_013 = MonsterId(135_013)
val mobHammeringRam_135_014 = MonsterId(135_014)
val mobTrudgingThomas_135_015 = MonsterId(135_015)
val mobAnglerTiger_135_016 = MonsterId(135_016)
val mobMegantereon_135_017 = MonsterId(135_017)
val mobIrateSheep_135_018 = MonsterId(135_018)
val mobCankercap_135_019 = MonsterId(135_019)
val mobTopplingTuber_135_020 = MonsterId(135_020)
val mobHadhayosh_135_021 = MonsterId(135_021)
val mobOvni_135_022 = MonsterId(135_022)

val mobEschanWorm_288_001 = MonsterId(288_001)
val mobEschanObdella_288_002 = MonsterId(288_002)
val mobEschanCrawler_288_003 = MonsterId(288_003)
val mobEschanCouerl_288_004 = MonsterId(288_004)
val mobEschanDhalmel_288_005 = MonsterId(288_005)
val mobEschanWeapon_288_006 = MonsterId(288_006)
val mobEschanVulture_288_007 = MonsterId(288_007)
val mobEschanSorcerer_288_008 = MonsterId(288_008)
val mobEschanCorse_288_009 = MonsterId(288_009)
val mobEschanGoobbue_288_010 = MonsterId(288_010)
val mobEschanSnapweed_288_011 = MonsterId(288_011)
val mobEschanWasp_288_012 = MonsterId(288_012)
val mobEschanCrab_288_013 = MonsterId(288_013)
val mobEschanPugil_288_014 = MonsterId(288_014)
val mobEschanTarichuk_288_015 = MonsterId(288_015)
val mobEschanBugard_288_016 = MonsterId(288_016)

val mobAziDahaka_288_050 = MonsterId(288_050)
val mobAziDragon_288_051 = MonsterId(288_051)

val mobWepwawet_288_100 = MonsterId(288_100)
val mobAglaophotis_288_105 = MonsterId(288_105)
val mobVidala_288_110 = MonsterId(288_110)
val mobGestalt_288_115 = MonsterId(288_115)
val mobRevetaur_288_120 = MonsterId(288_120)
val mobTangataManu_288_125 = MonsterId(288_125)
val mobGulltop_288_130 = MonsterId(288_130)
val mobVyala_288_135 = MonsterId(288_135)
val mobAngrboda_288_140 = MonsterId(288_140)
val mobCunnast_288_145 = MonsterId(288_145)
val mobFerrodon_288_150 = MonsterId(288_150)
val mobLustfulLydia_288_155 = MonsterId(288_155)

val mobIonos_288_200 = MonsterId(288_200)
val mobNosoi_288_205 = MonsterId(288_205)
val mobUmdhlebi_288_210 = MonsterId(288_210)
val mobSensualSandy_288_215 = MonsterId(288_215)
val mobBrittlis_288_220 = MonsterId(288_220)
val mobKamohoalii_288_225 = MonsterId(288_225)

val mobFleetstalker_288_300 = MonsterId(288_300)
val mobShockmaw_288_305 = MonsterId(288_305)
val mobUrmahlullu_288_310 = MonsterId(288_310)
val mobBlazewing_288_315 = MonsterId(288_315)
val mobPazuzu_288_320 = MonsterId(288_320)
val mobAlpluachra_288_325 = MonsterId(288_325)
val mobBucca_288_330 = MonsterId(288_330)
val mobPuca_288_335 = MonsterId(288_335)

val mobWrathare_288_400 = MonsterId(288_400)

val mobTrainingDummy_288_500 = MonsterId(288_500)
val mobPazuzuFetter_288_501 = MonsterId(288_501)
val mobFleetstalkerFireElemental_288_502 = MonsterId(288_502)
val mobFleetstalkerEarthElemental_288_503 = MonsterId(288_503)
val mobBlazewingFly_288_504 = MonsterId(288_504)
val mobUrmahlulluCrystal_288_505 = MonsterId(288_505)
val mobWrathareClone_288_506 = MonsterId(288_506)
